import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { HabitatIntactnessExplainerBU } from '@/components/NCExplainers/HabitatIntactnessExplainer';

import { GraphTile } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';
import { TableTile } from './components/table/TableTile';

export const DegradationDriversCard = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={8}>
      <NCCard explainer={<HabitatIntactnessExplainerBU />}>
        <NCCardHeader
          title={t('shared.ncaDetail.habitatIntactness.degradationDriversHistoric.title')}
          className='lg:grid-cols-[1fr_1fr]'
        />
        <NCCard2SectionLayout className='[&>*]:py-8'>
          <GraphTile />
          <StatsTile />
        </NCCard2SectionLayout>
      </NCCard>
      <NCCard>
        <NCCard2SectionLayout className='[&>*]:py-8 md:grid-cols-1'>
          <TableTile />
        </NCCard2SectionLayout>
      </NCCard>
    </Stack>
  );
};
